import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./editScenarioNewSlice";
import {
    Grid,
    Typography,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

function getStyles(name, sources, theme) {
	return {
		fontWeight:
			sources.indexOf(name) === -1
				? theme.typography.fontWeightRegular
				: theme.typography.fontWeightMedium,
	};
}

export default function MultipleSelectChip() {
	const theme = useTheme();

	const { dataSources, selectedDSs, selectedCustsCGs, selectedPDS, skuBreakdown } = useSelector(
		(store) => store.editScenarioNew
	);
	const dispatch = useDispatch();

	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	const handleChange = (source) => {
		if (selectedCustsCGs.length <= 0) {
			showMessage(
				"Please select at least one customer or customer group",
				"info"
			);
			return;
		}
		let DSR = [...selectedDSs];
		let index = DSR.findIndex((x) => x === source.dataSourceName);
		if(index !== -1){
			DSR.splice(index, 1);
		}
		else{
			DSR.push(source.dataSourceName);
			if(selectedPDS.length === 0 || selectedPDS === "" || selectedPDS === undefined){
				dispatch(setState("selectedPDS", source.dataSourceName));
				dispatch(setState("primaryDataSourceID", source.dataSourceID));
			}
		}
		if(selectedPDS.length !== 0 && selectedPDS !== "" && selectedPDS !== undefined && DSR.indexOf(selectedPDS) == -1){
			if(DSR.length > 0){
				const id = dataSources.find(
					(source) => source.dataSourceName === DSR[0]
				).dataSourceID;
				dispatch(setState("selectedPDS", DSR[0]));
				dispatch(setState("primaryDataSourceID", id));
			}else{
				dispatch(setState("selectedPDS", ""));
				dispatch(setState("primaryDataSourceID", ""));
			}
		}
		if(DSR.indexOf(skuBreakdown) == -1 && skuBreakdown != "External"){
			dispatch(setState("skuBreakdown", ""));
		}
        // if(DSR.indexOf("TTM") != -1 & skuBreakdown.length <= 0){
		// 	dispatch(setState("skuBreakdown", "TTM"));
		// }
		dispatch(setState("selectedDSs", DSR));
	};

	return (
		<div>
			{/* <FormControl sx={{ mt: 3, width: 700 }}>
				<InputLabel id="demo-multiple-chip-label">
					Select Data Sources
				</InputLabel>
				<Select
					labelId="demo-multiple-chip-label"
					id="demo-multiple-chip"
					multiple
					value={selectedDSs}
					onChange={handleChange}
					input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
					renderValue={(selected) => (
						<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
							{selected.map((value) => (
								<Chip key={value} label={value} />
							))}
						</Box>
					)}
					MenuProps={MenuProps}
				>
					{dataSources.map((source, index) => (
						<MenuItem
							key={index}
							value={source.dataSourceName}
							style={getStyles(
								source.dataSourceName,
								selectedDSs,
								theme
							)}
						>
							{source.dataSourceName}
						</MenuItem>
					))}
				</Select>
			</FormControl> */}
			<Grid container>
				{dataSources.map((source, index) => {
					return (
						<Grid item sm={6} md={2.2}>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "flex-start",
								}}
							>
								<FormControlLabel
									control={
										<Checkbox
											checked={selectedDSs.indexOf(source.dataSourceName) !== -1}
											onChange={(event) =>
												handleChange(source)
											}
											inputProps={{ "aria-label": "controlled" }}
											
										/>
									}
								/>

								<Typography sx={{ mt: 2.1, ml: -1,}}>
									{source.dataSourceName}
								</Typography>
							</Box>

						</Grid>
					);
				})}
			</Grid>
		</div>
	);
}
